import { Link } from '@mui/material';
import { IMAGE_FOLDER } from 'main/utils/constants';

type Props = {
    size: number;
}

export const LineLink = ({ size }: Props) => {
    return (
        <Link data-testid="line-link" href="https://lin.ee/JVt8sK6">
            <img
                src={`${IMAGE_FOLDER}/line.png`}
                alt="LINE"
                height={size}
            />
        </Link>
    )
}
